import { useEffect, useState } from "react";
import RiskAssessmentCard from "../../../../../shared/ui/RiskScoreCard/RiskAssessmentCard";
import { getTenantRiskFactors } from "../../../../../shared/services/apis";
import { useParams } from "react-router-dom";
import RiskSkeleton from "../../../../../shared/ui/RiskScoreCard/RiskSkeleton";

// --- Transaction Risk Weights ---
const getTransactionWeight = (taskName: string): string => {
  const taskLower = taskName.toLowerCase();
  if (taskLower.includes("acquisition price vs. comparable price"))
    return "25%";
  if (taskLower.includes("equity check size")) return "20%";
  if (taskLower.includes("placement timing")) return "5%";
  if (taskLower.includes("portfolio concentration risk")) return "15%";
  if (taskLower.includes("projected portfolio size")) return "20%";
  if (taskLower.includes("guarantees")) return "10%";
  if (
    taskLower.includes("new investment") ||
    taskLower.includes("new geography") ||
    taskLower.includes("new investment product/new geography")
  )
    return "30%";

  return "10%";
};

// --- Property Risk Weights ---
const getPropertyWeight = (taskName: string): string => {
  const taskLower = taskName.toLowerCase();
  if (taskLower.includes("class")) return "10%";
  if (taskLower.includes("age")) return "10%";
  if (taskLower.includes("location")) return "10%";
  if (
    taskLower.includes(
      "liquidity of the market /sub-market in which the property is located"
    )
  )
    return "10%";
  if (taskLower.includes("msa size")) return "0%";
  if (taskLower.includes("size")) return "60%";

  if (taskLower === "tenant concentration (%)") return "15%";
  if (taskLower === "tenant's sector concentration (%)") return "5%";
  if (taskLower === "tenant health ratio - residential (%)") return "0%";
  if (taskLower === "tenant health ratio - retail (%)") return "0%";
  if (taskLower === "rated tenants (%)") return "0%";
  if (taskLower === "property operational risks - # of tenants") return "15%";
  if (taskLower === "operating partner overall experience (years)")
    return "15%";
  if (taskLower === "operating partner's relationship with investcorp (#)")
    return "20%";
  if (taskLower === "operating partner's capacity (%)") return "15%";
  if (taskLower === "term of agreement with property manager (years)")
    return "8%";
  if (
    taskLower === "property manager's experience (based on on moodys' rating)"
  )
    return "0%";
  if (taskLower === "jv commitment (%)") return "0%";
  if (taskLower === "legal risks") return "2.5%";
  if (taskLower === "regulatory risks") return "2.5%";
  if (taskLower === "catastrophe risks") return "2.5%";

  return "0%";
};

interface Props {
  RiskFactorId: string;
}

export default function IdiosyncraticPropertyRisksCard({
  RiskFactorId,
}: Props) {
  const [selectedSubRiskId, setSelectedSubRiskId] = useState<string>("");
  const { tenantId } = useParams<{ tenantId: string }>();
  const [subRiskFactor, setSubRiskFactor] = useState<any[]>([]);
  const [riskPerimeters, setRiskPerimeters] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const refreshRiskScorecard = async () => {
      try {
        setLoading(true);
        console.log(tenantId, "it is in riskscroeooo");
        const response = await getTenantRiskFactors(tenantId || "");
        const riskFactors = response.data || response;
        console.log(riskFactors, "it is in market position");

        const selectedRiskFactor = riskFactors.find(
          (factor: any) => factor.id === RiskFactorId
        );

        if (selectedRiskFactor) {
          const subFactors = selectedRiskFactor.subRiskFactors.map(
            (sub: any) => ({
              id: sub.id,
              name: sub.name,
              tenantId: sub.tenantRiskFactorId,
              weight: sub.weight,
            })
          );

          setSubRiskFactor(subFactors);

          // Set default selection to first sub-risk factor
          if (subFactors.length > 0 && !selectedSubRiskId) {
            setSelectedSubRiskId(subFactors[0].id);
          }
          const defaultSubRiskId =
            subFactors.length > 0 ? subFactors[0].id : "";
          if (!selectedSubRiskId) setSelectedSubRiskId(defaultSubRiskId);

          // Set risk perimeters based on currently selected sub-risk factor
          // const currentSubRiskId = selectedSubRiskId || defaultSubRiskId;
            setRiskPerimeters(
            selectedRiskFactor.factorGroups
              .filter((group: any) => group.riskFactorId === RiskFactorId)
              .flatMap(
                (group: any) =>
                  group.result?.ratings?.map((rating: any) => ({
                    task: rating.task,
                    rating: rating.rating,
                    reasoning: rating.reasoning,
                    subRiskFactorId: group.subRiskFactorId,
                  })) || []
              )
          );
        } else {
          setSubRiskFactor([]);
          setRiskPerimeters([]);
        }

        console.log(subRiskFactor, "sub Facuturrdsssss");
        console.log(riskPerimeters, "risk parameters");
      } catch (error) {
        console.error("Failed to fetch risk factors:", error);
      } finally {
        setLoading(false);
      }
    };

    refreshRiskScorecard();
  }, [tenantId, RiskFactorId, selectedSubRiskId]);

  useEffect(() => {
    console.log(riskPerimeters, "freee use effect");
  }, [subRiskFactor, riskPerimeters]);

  // Filter risk parameters by selected sub-risk factor
  // const filteredRiskPerimeters = {
  //   ratings: riskPerimeters
  //     .filter((param) => param.subRiskFactorId === selectedSubRiskId)
  //     .map((param) => ({
  //       task: param.task,
  //       rating: param.rating,
  //       reasoning: param.reasoning,
  //     })),
  // };

  // Get weight function based on selected sub-risk factor
  // const getWeightFunction = () => {
  //   const selectedSubFactor = subRiskFactor.find(
  //     (sub) => sub.id === selectedSubRiskId
  //   );
  //   const subFactorName = selectedSubFactor?.name?.toLowerCase() || "";

  //   if (subFactorName.includes("transaction")) {
  //     return getTransactionWeight;
  //   } else if (subFactorName.includes("property")) {
  //     return getPropertyWeight;
  //   }
  //   return getTransactionWeight; // default
  // };

  // Show loading state
  if (loading) {
    return <RiskSkeleton />;
  }

  // Don't render until we have data
  if (subRiskFactor.length === 0) {
    return <div>No risk data available</div>;
  }

  return (
   <div className="px-4">
        {/* Show buttons only if more than one subRiskFactor exists */}
        {/* {subRiskFactor.length > 1 && (
          <div className="flex justify-center space-x-2 mb-4">
            {subRiskFactor.map((subFactor) => (
              <button
                key={subFactor.id}
                className={`px-3 py-1 text-sm font-light rounded-2xl border cursor-pointer transition-colors duration-200 ${
                  selectedSubRiskId === subFactor.id
                    ? "bg-gray-50 text-gray-700 border-gray-300"
                    : "bg-white text-gray-600 border-gray-200 hover:bg-gray-50"
                }`}
                onClick={() => setSelectedSubRiskId(subFactor.id)}
              >
                {subFactor.name}
              </button>
            ))}
          </div>
        )} */}
  
        {/* Render RiskAssessmentCard for each subRiskFactor */}
        {subRiskFactor.map((sub) => {
          const subFiltered = {
            ratings: riskPerimeters
              .filter((param) => param.subRiskFactorId === sub.id)
              .map((param) => ({
                task: param.task,
                rating: param.rating,
                reasoning: param.reasoning,
              })),
          };
  
           const getWeightFunction = () => {
          const subName = sub.name.toLowerCase();
          if (subName.includes("transaction")) return getTransactionWeight;
          if (subName.includes("property")) return getPropertyWeight;
          return getTransactionWeight; // default
        };
  
          return (
            <RiskAssessmentCard
              key={sub.id}
              title={sub.name || "Idiosyncratic Property Risk"}
              apiResponse={subFiltered}
              getWeightForTask={getWeightFunction()}
            />
          );
        })}
      </div>
  );
}
